import { render, staticRenderFns } from "./TariffMiniKaskoItem.vue?vue&type=template&id=69b2001f&scoped=true&"
import script from "./TariffMiniKaskoItem.vue?vue&type=script&lang=ts&"
export * from "./TariffMiniKaskoItem.vue?vue&type=script&lang=ts&"
import style0 from "./TariffMiniKaskoItem.vue?vue&type=style&index=0&id=69b2001f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b2001f",
  null
  
)

export default component.exports